/** Default sync/auth server URL, baked in at build time — render.yaml sets
 *  `VITE_SYNC_URL` for the hosted web build, so hosted users never type a URL:
 *  they just sign in. A stored `sync_url` (Settings → Sync → Advanced) overrides
 *  it; builds without the env var fall back to "" (manual entry).
 *
 *  Used by BOTH the auth store (signup/login/refresh/logout) and the sync store,
 *  which talk to the same server — keep them resolving the URL the same way. */
export const DEFAULT_SYNC_URL = import.meta.env.VITE_SYNC_URL ?? "";
